import styled, { css, keyframes } from "styled-components";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// constants
import { NUDGE_IMAGE_WRAPPER, ANIMATED_BORDER } from "./constants";

// animation
import { BELL_ANIMATION, BORDER_ANIMATION, SHIMMER_ANIMATION } from "./animation";

const cardGradient = `linear-gradient(330deg, #eddcf2 10%, #ffffff 45%)`;

export const NudgeContainer = styled.div<{ gradientBg: boolean }>(({ theme, gradientBg }) => {
    return {
        padding: theme.spacing.medium,
        margin: `calc(${theme.spacing.medium} * -1) ${theme.spacing.medium} 0 ${theme.spacing.medium}`,
        borderRadius: theme.spacing.medium,
        position: "relative",
        background: gradientBg ? cardGradient : "#fff",
    };
});

export const ContentWrapper = styled.div`
    position: relative;
    z-index: 1;
`;

const rotateBorder = keyframes`${BORDER_ANIMATION}`;

export const AnimatedBorder = styled.div(
    ({ theme }) =>
        css`
            position: absolute;
            width: 100%;
            height: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: ${theme.spacing.medium};
            overflow: hidden;

            &::before {
                content: "";
                background: conic-gradient(transparent 265deg, #9f4097 90%, transparent 0%);
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(115deg);
                aspect-ratio: 1;
                width: 110%;
                animation: ${rotateBorder} 5s cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }

            &::after {
                content: "";
                background: ${cardGradient};
                border-radius: inherit;
                position: absolute;
                height: calc(100% - ${ANIMATED_BORDER.OFFSET * 2}px);
                width: calc(100% - ${ANIMATED_BORDER.OFFSET * 2}px);
                inset: ${ANIMATED_BORDER.OFFSET}px;
            }
        `,
);

export const CardImage = styled(Image)`
    object-fit: contain;
    width: 100%;
    height: 100%;
`;

export const NudgeImageWrapper = styled.div`
    position: absolute;
    bottom: ${NUDGE_IMAGE_WRAPPER.BOTTOM}px;
    right: ${NUDGE_IMAGE_WRAPPER.RIGHT}px;
    height: ${NUDGE_IMAGE_WRAPPER.HEIGHT}px;
    width: ${NUDGE_IMAGE_WRAPPER.WIDTH}px;
`;

export const NudgeCtaWrapper = styled.div(({ theme }) => {
    return {
        backgroundColor: "#9F4097", // color not available in dls
        padding: `6px 8px`,
        margin: `${theme.spacing.small} 0 0`,
        width: "fit-content",
        borderRadius: `calc(${theme.spacing.large} * 2)`,
        display: "inline-flex",
        gap: `${theme.spacing.xxSmall}`,
    };
});

const bellAnimation = keyframes`${BELL_ANIMATION}`;

export const BellIconWrapper = styled.div(
    ({ theme }) => css`
        position: relative;
        height: ${theme.spacing.medium};
        width: ${theme.spacing.medium};
        animation: ${bellAnimation} 5s linear 2s infinite;
        transform-origin: top center;
    `,
);

export const NudgePostInterestHeadingWrapper = styled.div(({ theme }) => {
    return {
        background: "linear-gradient(90deg, #c8f9e5 0%, rgba(200, 249, 229, 0) 100%)",
        borderRadius: `calc(${theme.spacing.large} * 2)`,
        width: "fit-content",
        display: "flex",
        gap: theme.spacing.xxSmall,
        padding: "6px 12px",
        alignItems: "center",
    };
});

export const NudgePostInterestTextWrapper = styled.div(({ theme }) => {
    return {
        margin: `${theme.spacing.small} 0 0`,
    };
});

const shimmerAnimation = keyframes`${SHIMMER_ANIMATION}`;

const shimmerAnimationCSS = css`
    ${shimmerAnimation} 2s infinite linear;
`;

export const ShimmerCta = styled.div`
    width: ${props => `calc(${props.theme.spacing.large}*7)`};
    height: 26px;
    background: linear-gradient(90deg, #e2e2e7 0%, #d0d1d7 52.08%, #e2e2e7 100%);
    background-size: 1000px 100%;
    animation: ${shimmerAnimationCSS};
    border-radius: ${props => props.theme.cornerRadius.xLarge};
`;

export const ShimmerRow1 = styled.div`
    width: ${props => `calc(${props.theme.spacing.large}*10)`};
    height: 14px;
    margin-top: ${props => props.theme.spacing.small};
    background: linear-gradient(90deg, #e2e2e7 0%, #d0d1d7 52.08%, #e2e2e7 100%);
    background-size: 1000px 100%;
    animation: ${shimmerAnimationCSS};
`;

export const ShimmerRow2 = styled.div`
    width: ${props => `calc(${props.theme.spacing.large}*10)`};
    height: 14px;
    margin-top: 6px;
    background: linear-gradient(90deg, #e2e2e7 0%, #d0d1d7 52.08%, #e2e2e7 100%);
    background-size: 1000px 100%;
    animation: ${shimmerAnimationCSS};
`;
